import { render } from "./QuestDialog15.vue?vue&type=template&id=5a87d4de"
import script from "./QuestDialog15.vue?vue&type=script&lang=js"
export * from "./QuestDialog15.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questDialogs/QuestDialog15.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a87d4de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a87d4de', __exports__)) {
    api.reload('5a87d4de', __exports__)
  }
  
  module.hot.accept("./QuestDialog15.vue?vue&type=template&id=5a87d4de", () => {
    api.rerender('5a87d4de', render)
  })

}


export default __exports__